<template>
	<div class="all">
		<el-table :height="590" class="table" ref="multipleTable" :border="false" :data="tableData" tooltip-effect="dark"
			style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
			<el-table-column align="center" type="selection" label="">
			</el-table-column>
			<el-table-column align="center" label="商品信息" width="490">
				<template slot-scope="scope">
					<div class="d-flex flex-column j-sb a-center" style="font-size: 0.75rem;">
						<div class="w-100 d-flex j-sb a-center" style="margin-bottom: 1.38rem;">
							<span>订单号：{{scope.row.order_sn}}</span>
							<span>下单时间：{{scope.row.add_time}}</span>
						</div>
						<div class="w-100 d-flex j-start a-start">
							<img :src="scope.row.goods_list[0].goods_thumb" alt="" style="width: 3rem;height: 3rem;margin-right: 0.44rem;">
							<span class="text-multiple-ellipsis" style="line-height: 1;width: 13.75rem;color: #000000;">{{scope.row.goods_list[0].goods_name}}</span>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="order_goods_num" label="数量">
			</el-table-column>
			<el-table-column align="center" prop="order_fee" label="订单金额" show-overflow-tooltip>
			</el-table-column>
			<el-table-column align="center" prop="total_fee" label="实付款" show-overflow-tooltip>
			</el-table-column>
			<el-table-column align="center" prop="order_status_remark" label="订单状态" show-overflow-tooltip>
			</el-table-column>
			<el-table-column align="center" prop="" label="操作" width="240" show-overflow-tooltip>
				<template slot-scope="scope">
					<div class="d-flex flex-column j-sb a-center">
						<div class="d-flex j-sb a-center" style="margin-bottom: 2.06rem;cursor: pointer;" @click="openView(scope.row)">
							<span>{{scope.row.store_name}}</span>
							<img src="../../../assets/order/jiantoujindian@2x.png" alt=""
								style="width: 0.63rem;height: 0.63rem;margin-left: 0.44rem;">
						</div>
						<el-button round style="width: 7.03rem;height: 1.41rem;color: #FFFFFF;font-size: 0.75rem; outline: none;border: none;padding: 0; background: #1E69FF;" @click="$router.push({path:'detail',query:{id:scope.row.order_id,atid:scope.row.agent_id}})">订单详情</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<footer class="d-flex j-sb a-center">
			<div class="button" @click="print()">打印订单</div>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
			</el-pagination>
		</footer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				currentPage: 1, //初始页
				pageSize: 5, //    每页的数据
				tableData: [],
				multipleSelection: [],
				total_records:0
			}
		},
		methods: {
			openDetail(e) {
				console.log(e)
				this.$router.push('company_detail')
			},
			handleSelectionChange(val) {
				console.log(val)
				console.log(this.multipleSelection)
				this.multipleSelection = val;
			},
			handleEdit(index, row) {
				console.log(index, row);
			},
			openView(row){
				this.$router.push({
						name: 'shop_detail',
						params: {
							id: row.agent_id
						}
				})
			},
			handleDelete(index, row) {
				console.log(index, row);
				this.tableData.splice(index, 1)
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.order_list()
			},
			print(){
				this.$print(this.$refs.multipleTable)
			},
			order_list(){
				
				let params = {
					act:'order_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:this.pageSize,
					page:this.currentPage,
					type:102
				}
				
				this.$api.order_list(params).then((res)=>{
					if(res.code == 0){
						this.tableData = res.data
						this.total_records = res.total_records
					}
				})
			}
			
		},
		created() {
			this.order_list()
		}
	}
</script>

<style lang="scss" scoped>
	.table {
		width: 100%;
		background: #FFFFFF;
		border-radius: 0 0 6px 6px;
		overflow: hidden;
	}

	footer {
		width: 100%;
		height: 3.85rem;
		background: #FFFFFF;
		margin-top: 1.44rem;
		border-radius: 6px;
		padding: 0 1rem;
		box-sizing: border-box;
		.button{
			width: 5.63rem;
			height: 1.25rem;
			color: #000000;
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px solid #000000;
			border-radius: 0.625rem;
			font-size: 0.75rem;
			margin: 0 1.1rem;
			cursor: pointer;
			box-sizing: border-box;
			&:hover{
				border: 2px solid #000000;
				font-weight: bold;
			}
		}
	}
</style>
